module.exports = __webpack_public_path__ + "img/loading.13de04a2.gif";